/* unplugin-vue-components disabled */import { render } from "./UnifiedStatistics.vue?vue&type=template&id=66690212&scoped=true&ts=true"
import script from "./UnifiedStatistics.vue?vue&type=script&lang=ts"
export * from "./UnifiedStatistics.vue?vue&type=script&lang=ts"

import "./UnifiedStatistics.vue?vue&type=style&index=0&id=66690212&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66690212"]])

export default __exports__